import { ArrayParam, ObjectParam, StringParam, NumberParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { dateFormat } from '@app/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { RegularMonitoringColumns, RegularMonitoringColumnsSchedule } from './types'

export const columnTitleMap: Record<keyof RegularMonitoringColumns, string> = {
  monitoringType: 'Тип мониторинга',
  subtype: 'Подтип',
  promotionName: 'Рекламное мероприятие',
  promoDateFrom: 'Дата начала РМ Лента',
  promoDateTo: 'Дата оконч. РМ Лента',
  store: 'ТК Ленты',
  cluster: 'Кластер',
  contractor: 'Подрядчик',
  competitorsCount: 'Кол-во конкурентов',
  isLaunchAccess: 'Доступ к запуску'
}

export const columnTitleMapSchedule: Record<keyof RegularMonitoringColumnsSchedule, string> = {
  startAt: 'Старт',
  gettingDateAt: 'Получение данных',
  processingDateAt: 'Обработка данных',
  dateDeadline: 'Выставление новой цены'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringSubtypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedMonitoringSubtypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.promoIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam

  // TODO: [clustersGroupIds] группа кластеров пока не используется, поэтому код временно закомментирован, в будущем вернем
  // [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam
} as const

export const tableSearchQuerySchema: TableSearchQuerySchema<
RegularMonitoringColumns & RegularMonitoringColumnsSchedule
> = {
  'table-monitoringType': StringParam,
  'table-subtype': StringParam,
  'table-promotionName': StringParam,
  'table-promoDateFrom': ObjectParam,
  'table-promoDateTo': ObjectParam,
  'table-store': StringParam,
  'table-cluster': StringParam,
  'table-contractor': StringParam,
  'table-competitorsCount': NumberParam,
  'table-startAt': ObjectParam,
  'table-gettingDateAt': ObjectParam,
  'table-processingDateAt': ObjectParam,
  'table-dateDeadline': ObjectParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<RegularMonitoringColumns & RegularMonitoringColumnsSchedule> =
  {
    monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    subtype: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    promotionName: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    promoDateFrom: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    },
    promoDateTo: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    },
    store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    contractor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
    competitorsCount: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
    startAt: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    },
    gettingDateAt: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    },
    processingDateAt: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    },
    dateDeadline: {
      type: columnSearchSchemaOptionType.DATE_RANGE,
      titleWrapperProps: titleWrapperDateProps,
      controlProps: { format: dateFormat.DD_MM_YYYY }
    }
  }
